import { PromptStatus } from '@/types/request';
import { InquiryStatus } from '@/types/response/inquiry';

export enum NOTIFY_STATUS {
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  INFO = 'info',
  CONFIRM = 'confirm',
}

export const genderOptions = [
  {
    label: '男性',
    value: 1,
  },
  {
    label: '女性',
    value: 2,
  },
  {
    label: 'その他',
    value: 3,
  },
];

export const userStatus = {
  active: '有効',
  deaActive: '無効',
};
export const reportStatus = {
  pending: 'pending',
  accept: 'accept',
  reject: 'reject',
};

export const EventFeeType = {
  FREE: 'free',
  PAID: 'paid',
};

export enum ContentRedirectType {
  NONE = 'none',
  SURVEY = 'survey',
  URL = 'url',
}

export const userStatusColors = {
  active: 'green',
  deaActive: 'red',
};

export const reportStatusColors = {
  pending: 'yellow',
  accept: 'green',
  reject: 'red',
};

export const verifyStatus = {
  true: '〇',
  false: '✖',
};

export const verifyStatusColors = {
  true: 'green',
  false: 'red',
};

export const postTypes = {
  easy: 'Easy',
  freeInput: 'Free Input',
};

export const postTypeColors = {
  easy: 'green',
  freeInput: 'red',
};

export const postStatus = {
  public: 'Public',
  draft: 'Draft',
  canceled: 'Canceled',
  temporary: 'Temporary',
  hidden: 'hidden',
};

export enum CALENDAR_POST_STATUS_VALUE {
  PUBLIC = 'public',
  DRAFT = 'draft',
  HIDDEN = 'hidden',
}

export enum Status {
  DRAFT,
  PUBLIC,
  SCHEDULED,
}

export const promptStatusText = {
  [PromptStatus.DRAFT]: '下書き',
  [PromptStatus.ENABLE]: '有効',
};

export const promptStatusColors = {
  [PromptStatus.DRAFT]: 'default',
  [PromptStatus.ENABLE]: 'success',
};

export const postStatusColors = {
  public: 'success',
  draft: 'default',
  canceled: 'error',
  temporary: 'warning',
};

export const notificationStatus = [
  {
    label: '未配信',
    value: 0,
  },
  {
    label: '配信予定',
    value: 1,
  },
];

export const eventFeeTypeOptions = [
  {
    label: '無料',
    value: 'free',
  },
  {
    label: '有料',
    value: 'paid',
  },
];

export const contentRedirectOptions = [
  {
    label: 'どこにも遷移しない',
    value: ContentRedirectType.NONE,
  },
  {
    label: 'おはなし（アンケート）への遷移',
    value: ContentRedirectType.SURVEY,
  },
  {
    label: '外部URLへの遷移',
    value: ContentRedirectType.URL,
  },
];

export const eventStatus = [
  {
    label: '公開予定',
    value: 1,
  },
  {
    label: '非公開',
    value: 0,
  },
];

export const statusOptions = [
  {
    label: '非公開',
    value: Status.DRAFT,
  },
  {
    label: '公開予定',
    value: Status.PUBLIC,
  },
];

export const statusOptionsFull = [
  {
    label: '非公開',
    value: Status.DRAFT,
  },
  {
    label: '公開予定',
    value: Status.SCHEDULED,
  },
  {
    label: '公開',
    value: Status.PUBLIC,
  },
];

export const statusJP = {
  DRAFT: '非公開',
  PUBLIC: '公開',
  SCHEDULED: '公開予定',
};

export const bannerStatus = [
  {
    label: '公開予定',
    value: Status.SCHEDULED,
  },
  {
    label: '非公開',
    value: Status.DRAFT,
  },
];
export const contentStatus = [
  {
    label: '公開',
    value: 1,
  },
  {
    label: '下書き',
    value: 0,
  },
];

export const calendarPostStatus = [
  {
    label: '公開',
    value: 1,
  },
  {
    label: '下書き',
    value: 0,
  },
];

export const surveyStatus = [
  {
    label: '公開',
    value: 1,
  },
  {
    label: '下書き',
    value: 0,
  },
];

export const promptStatus = [
  {
    label: '有効',
    value: PromptStatus.ENABLE,
  },
  {
    label: '下書き',
    value: PromptStatus.DRAFT,
  },
];

export const postCodeTypeOptions = [
  {
    label: '全て',
    value: 0,
  },
  {
    label: '郵便局指定',
    value: 1,
  },
];

export const mustUpdateOptions = [
  {
    label: '必須',
    value: 1,
  },
  {
    label: '任意',
    value: 0,
  },
];

export const articleStatus = [
  {
    label: '公開予定',
    value: 1,
  },
  {
    label: '下書き',
    value: 0,
  },
];

export const offerStatus = [
  {
    label: '公開',
    value: 1,
  },
  {
    label: '下書き',
    value: 0,
  },
];

export const inquiryStatusColors = {
  [InquiryStatus.NOT_ANSWER]: 'red',
  [InquiryStatus.ANSWERED]: 'green',
};

export const inquiryStatus = {
  [InquiryStatus.NOT_ANSWER]: '未回答',
  [InquiryStatus.ANSWERED]: '回答済み',
};

export const inquiryStatusOption = [
  {
    label: '未回答',
    value: InquiryStatus.NOT_ANSWER,
  },
  {
    label: '回答済み',
    value: InquiryStatus.ANSWERED,
  },
];

export enum PromptType {
  IMAGE_FREE_INPUT = 'imageFreeInput',
  TEXT_FREE_INPUT = 'textFreeInput',
  TITLE_FREE_INPUT = 'titleFreeInput',
  CONTENT_FREE_INPUT = 'contentFreeInput',
  IMAGE_EASY_INPUT = 'imageEasyInput',
  TEXT_EASY_INPUT = 'textEasyInput',
  TITLE_EASY_INPUT = 'titleEasyInput',
  CONTENT_EASY_INPUT = 'contentEasyInput',
  AUTO_GENERATE = 'autoGenerate',
}

export enum DISPLAY_MODE {
  DEFAULT = 'default',
  REPORT = 'report',
}

export const modulesReactQuill = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ['bold', 'italic', 'underline', 'strike'],
    ['blockquote'],
    [{ direction: 'rtl' }],
    [{ color: [] }, { background: [] }],
    [{ align: [] }],
    ['link'],
  ],
  clipboard: {
    matchVisual: false,
  },
};
